import GroupLogo from './GroupLogo';
import '../App.css';
import PageLayout from "./PageLayout";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

function Contact() {
  const [activeTab, setActiveTab] = useState("contact");

  const [formData, setFormData] = useState({
    domaineFormation: "",
    formationSouhaitee: "",
    prenom: "",
    nom: "",
    email: "",
    telephone: "",
    commentaire: "",
    objet: "",
    message: "",
    acceptRGPD: false,
    honeypot: ""
  });

  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [categories, setCategories] = useState([]);
  const [formations, setFormations] = useState([]);

  // Récupération des catégories au montage
  useEffect(() => {
    fetch("https://auto-formations.fr/api/fetch_categories.php")
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch((err) => console.error("Erreur chargement catégories :", err));
  }, []);

  // Récupération des formations quand domaineFormation change
  useEffect(() => {
    if (formData.domaineFormation) {
      fetch("https://auto-formations.fr/api/fetch_formations.php")
        .then((res) => res.json())
        .then((data) => {
          // filtrer formations par idCategorie
          const filtered = data.filter(
            (f) => String(f.idCategorie) === formData.domaineFormation
          );
          setFormations(filtered);
        })
        .catch((err) => console.error("Erreur chargement formations :", err));
    } else {
      setFormations([]);
    }
  }, [formData.domaineFormation]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setFeedback(null);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "domaineFormation" ? { formationSouhaitee: "" } : {}),
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.prenom.trim()) newErrors.prenom = "Prénom requis";
    if (!formData.nom.trim()) newErrors.nom = "Nom requis";
    if (!formData.email.trim()) newErrors.email = "Email requis";
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email))
      newErrors.email = "Email invalide";
    if (!formData.telephone.trim()) newErrors.telephone = "Téléphone requis";
    if (!formData.acceptRGPD)
      newErrors.acceptRGPD = "Vous devez accepter l'utilisation des données";

    if (activeTab === "contact") {
      if (!formData.domaineFormation)
        newErrors.domaineFormation = "Sélectionnez un domaine";
    }

    if (activeTab === "autre") {
      if (!formData.objet.trim()) newErrors.objet = "Objet requis";
      if (!formData.message.trim()) newErrors.message = "Message requis";
    }

    return newErrors;
  };

 const handleSubmit = (e) => {
  e.preventDefault();
  if (sending) return;
  setFeedback(null);
  if (formData.honeypot) return; // blocage robots
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setErrors({});
  setSending(true);
  fetch("https://auto-formations.fr/api/send_mail.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        setFeedback({ type: "success", message: "Votre message a bien été envoyé. Merci pour votre confiance !" });
        setFormData({
          domaineFormation: "",
          formationSouhaitee: "",
          prenom: "",
          nom: "",
          email: "",
          telephone: "",
          commentaire: "",
          objet: "",
          message: "",
          acceptRGPD: false,
          honeypot: ""
        });
      } else {
        setFeedback({ type: "danger", message: data.message || "Votre message n’a pas pu être envoyé. Veuillez réessayer." });
      }
    })
    .catch((err) => {
      console.error("Erreur envoi :", err);
      setFeedback({ type: "danger", message: "L’envoi a échoué. Réessayez ou contactez-nous directement par email ou téléphone." });
    }).finally(() => setSending(false));
};

  return (
    <PageLayout title="Parlons de votre projet." eyebrow="LE PREMIER PAS, C’EST UN ÉCHANGE" intro="Une envie d’apprendre, une formation en tête ou simplement une question ? Présentez-nous votre besoin.">
      <div className="contact-layout">
      <aside className="contact-sidebar"><p className="page-eyebrow">FAISONS CONNAISSANCE</p><h2>À votre écoute,<br />pour la suite.</h2><p>Utilisez le formulaire ou contactez-nous directement.</p><a className="contact-method" href="mailto:contact@auto-formations.fr"><FiMail aria-hidden="true" /><span><small>PAR EMAIL</small>contact@auto-formations.fr</span></a><a className="contact-method" href="tel:+33387884774"><FiPhone aria-hidden="true" /><span><small>PAR TÉLÉPHONE</small>03 87 88 47 74</span></a><div className="contact-method"><FiMapPin aria-hidden="true" /><span><small>NOTRE ADRESSE</small>182 rue Lavoisier<br />57600 Oeting</span></div><div className="contact-group">Auto Formations, une entreprise du groupe<GroupLogo /></div></aside>
      <div className="contact-form-container">
      {/* Onglets */}
      <div className="contact-tabs" role="group" aria-label="Type de demande">
        <button
          type="button"
          className={`btn me-2 ${
            activeTab === "contact" ? "btn-primary" : "btn-outline-primary"
          }`}
          aria-pressed={activeTab === "contact"}
          onClick={() => handleTabClick("contact")}
        >
          Demande de contact
        </button>
        <button
          type="button"
          className={`btn ${
            activeTab === "autre" ? "btn-primary" : "btn-outline-primary"
          }`}
          aria-pressed={activeTab === "autre"}
          onClick={() => handleTabClick("autre")}
        >
          Autre sujet
        </button>
      </div>

      <form onSubmit={handleSubmit} className="surface-panel contact-form" aria-busy={sending}>
        <h2>{activeTab === "contact" ? "Votre projet de formation" : "Votre message"}</h2>
        <p className="form-intro">Les champs marqués d’un astérisque sont obligatoires.</p>
        {feedback && <div className={`alert alert-${feedback.type}`} role={feedback.type === "danger" ? "alert" : "status"}>{feedback.message}</div>}
        {/* Champ caché anti-robots */}
        <input
          type="text"
          name="honeypot"
          value={formData.honeypot}
          onChange={handleChange}
          style={{ display: "none" }}
        />

        {/* ========== Onglet Contact ========== */}
        {activeTab === "contact" && (
          <div>
            {/* Infos perso */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-prenom">Prénom *</label>
                <input
                  type="text"
                  className="form-control"
                  name="prenom"
                  id="contact-prenom"
                  aria-invalid={Boolean(errors.prenom)}
                  aria-describedby={errors.prenom ? "error-prenom" : undefined}
                  value={formData.prenom}
                  onChange={handleChange}
                />
                {errors.prenom && <div id="error-prenom" className="text-danger small">{errors.prenom}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-nom">Nom *</label>
                <input
                  type="text"
                  className="form-control"
                  name="nom"
                  id="contact-nom"
                  aria-invalid={Boolean(errors.nom)}
                  aria-describedby={errors.nom ? "error-nom" : undefined}
                  value={formData.nom}
                  onChange={handleChange}
                />
                {errors.nom && <div id="error-nom" className="text-danger small">{errors.nom}</div>}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-email">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  id="contact-email"
                  aria-invalid={Boolean(errors.email)}
                  aria-describedby={errors.email ? "error-email" : undefined}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <div id="error-email" className="text-danger small">{errors.email}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-telephone">Téléphone *</label>
                <input
                  type="tel"
                  className="form-control"
                  name="telephone"
                  id="contact-telephone"
                  aria-invalid={Boolean(errors.telephone)}
                  aria-describedby={errors.telephone ? "error-telephone" : undefined}
                  value={formData.telephone}
                  onChange={handleChange}
                />
                {errors.telephone && <div id="error-telephone" className="text-danger small">{errors.telephone}</div>}
              </div>
            </div>

            {/* Catégorie */}
            <div className="mb-3">
              <label className="form-label" htmlFor="contact-domaineFormation">Domaine de formation *</label>
              <select
                className="form-select"
                name="domaineFormation"
                  id="contact-domaineFormation"
                  aria-invalid={Boolean(errors.domaineFormation)}
                  aria-describedby={errors.domaineFormation ? "error-domaineFormation" : undefined}
                value={formData.domaineFormation}
                onChange={handleChange}
              >
                <option value="">Sélectionnez un domaine</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
              {errors.domaineFormation && (
                <div id="error-domaineFormation" className="text-danger small">{errors.domaineFormation}</div>
              )}
            </div>

            {/* Formations dynamiques */}
            {formations.length > 0 && (
              <div className="mb-3">
                <label className="form-label" htmlFor="contact-formationSouhaitee">Formation souhaitée (facultatif)</label>
                <select
                  className="form-select"
                  name="formationSouhaitee"
                  id="contact-formationSouhaitee"
                  aria-invalid={Boolean(errors.formationSouhaitee)}
                  aria-describedby={errors.formationSouhaitee ? "error-formationSouhaitee" : undefined}
                  value={formData.formationSouhaitee}
                  onChange={handleChange}
                >
                  <option value="">Sélectionnez une formation</option>
                  {formations.map((f) => (
                    <option key={f.id} value={f.id}>
                      {f.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Commentaire */}
            <div className="mb-3">
              <label className="form-label" htmlFor="contact-commentaire">Commentaire</label>
              <textarea
                className="form-control"
                name="commentaire"
                  id="contact-commentaire"
                  aria-invalid={Boolean(errors.commentaire)}
                  aria-describedby={errors.commentaire ? "error-commentaire" : undefined}
                rows="4"
                value={formData.commentaire}
                onChange={handleChange}
              ></textarea>
            </div>
          </div>
        )}

        {/* ========== Onglet Autre sujet ========== */}
        {activeTab === "autre" && (
          <div>
            {/* Infos perso (idem) */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-prenom">Prénom *</label>
                <input
                  type="text"
                  className="form-control"
                  name="prenom"
                  id="contact-prenom"
                  aria-invalid={Boolean(errors.prenom)}
                  aria-describedby={errors.prenom ? "error-prenom" : undefined}
                  value={formData.prenom}
                  onChange={handleChange}
                />
                {errors.prenom && <div id="error-prenom" className="text-danger small">{errors.prenom}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-nom">Nom *</label>
                <input
                  type="text"
                  className="form-control"
                  name="nom"
                  id="contact-nom"
                  aria-invalid={Boolean(errors.nom)}
                  aria-describedby={errors.nom ? "error-nom" : undefined}
                  value={formData.nom}
                  onChange={handleChange}
                />
                {errors.nom && <div id="error-nom" className="text-danger small">{errors.nom}</div>}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-email">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  id="contact-email"
                  aria-invalid={Boolean(errors.email)}
                  aria-describedby={errors.email ? "error-email" : undefined}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <div id="error-email" className="text-danger small">{errors.email}</div>}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label" htmlFor="contact-telephone">Téléphone *</label>
                <input
                  type="tel"
                  className="form-control"
                  name="telephone"
                  id="contact-telephone"
                  aria-invalid={Boolean(errors.telephone)}
                  aria-describedby={errors.telephone ? "error-telephone" : undefined}
                  value={formData.telephone}
                  onChange={handleChange}
                />
                {errors.telephone && <div id="error-telephone" className="text-danger small">{errors.telephone}</div>}
              </div>
            </div>

            {/* Objet */}
            <div className="mb-3">
              <label className="form-label" htmlFor="contact-objet">Objet *</label>
              <input
                type="text"
                className="form-control"
                name="objet"
                  id="contact-objet"
                  aria-invalid={Boolean(errors.objet)}
                  aria-describedby={errors.objet ? "error-objet" : undefined}
                value={formData.objet}
                onChange={handleChange}
              />
              {errors.objet && <div id="error-objet" className="text-danger small">{errors.objet}</div>}
            </div>

            {/* Message */}
            <div className="mb-3">
              <label className="form-label" htmlFor="contact-message">Votre message *</label>
              <textarea
                className="form-control"
                name="message"
                  id="contact-message"
                  aria-invalid={Boolean(errors.message)}
                  aria-describedby={errors.message ? "error-message" : undefined}
                rows="4"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && <div id="error-message" className="text-danger small">{errors.message}</div>}
            </div>
          </div>
        )}

        {/* RGPD */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            name="acceptRGPD"
            id="contact-consent"
            checked={formData.acceptRGPD}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="contact-consent">
            En poursuivant, j’accepte que MUVO utilise mes données pour me
            contacter afin d’approfondir mon projet.
          </label>
          {errors.acceptRGPD && (
            <div className="text-danger small">{errors.acceptRGPD}</div>
          )}
        </div>

        <p className="small"><Link to="/politique-confidentialite">Consulter la politique de confidentialité</Link></p>
        <button type="submit" disabled={sending} className="btn btn-primary w-100">
          {sending ? "Envoi en cours…" : "Envoyer ma demande"}
        </button>
        <span className="small d-block mt-2">* : Champs obligatoires</span>
      </form>
    </div></div></PageLayout>
  );
}

export default Contact;
